export enum PlanStatusEnum {
  ACTIVE = 'Active',
  TERMINATED = 'Terminated',
  FROZEN = 'Frozen'
}
